import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import { triggerError } from 'actions/gallery';
import i18n from 'i18n';

export const stateToProps = ({ triggerError }) => ({
  error: triggerError
});

export const dispatchToProps = (dispatch) => ({
  removeError: () => {
    dispatch(triggerError(null));
  }
});

export default class ErrorModal extends Component {
  static propTypes = {
    error: PropTypes.shape({
      message: PropTypes.string,
      title: PropTypes.string,
      messageKey: PropTypes.string,
      titleKey: PropTypes.string
    }).isRequired,
    removeError: PropTypes.func.isRequired
  };

  removeError = () => {
    this.props.removeError();
  };

  render() {
    const { error } = this.props;

    let title = error.title;
    if (!title && error.titleKey) {
      title = i18n(error.titleKey)();
    }

    let message = error.message;
    if (!message && error.messageKey) {
      message = i18n(error.messageKey)();
    }

    return (
      <Modal
        id="ErrorModal"
        title={title}
        contentAbove={message}
        onClose={this.removeError}
        buttons={[
          {
            text: i18n('component.ErrorModal.okButtonText')(),
            id: 'remove-error-button',
            onClick: this.removeError
          }
        ]}
      />
    );
  }
}
